// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__2_xnc","labelText":"label_labelText__3ylZt","bold":"label_bold__2NQUe"};